<template>
  <div id="login">
    <div class="right" style="width: 100%;">
      <div class="right-content" style="justify-content: end;">
        <div class="top">
          <img src="../../assets/icon/qrc.png" alt />

          <span style="margin: 0 10px;color: #eee">|</span>
          <span>忘记密码</span>
        </div>
        <div class="main">
          <h1>忘记密码</h1>
          <div class="phone">
            <!-- <span class="district">中国+86</span>
            -->
            <span>
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </span>
            <input type="text" v-model="phoneNumber" placeholder="请输入手机号" />
          </div>
          <div class="code">
            <input ref="code" v-model="imgToken" type="text" placeholder="请输入图形验证码" />
            <img @click="changeImg" class="imageCaptchaUrl" :src="imageCaptchaUrl" alt />
          </div>
          <div class="code">
            <input ref="code" v-model="phoneCode" id="code" type="text" placeholder="请填写6位短信验证码" />
            <a href="javascript:;" @click="loginTo" class="text">获取短信验证码</a>
          </div>
          <div class="password">
            <input
              ref="password"
              v-model="passWord"
              id="password"
              type="password"
              placeholder="8-20位字符，包含字母和数字"
            />
            <img
              v-if="isok"
              style="width: 19px;height: 11px"
              @click="isshow"
              :src="passwordImg"
              alt
            />
            <img
              v-if="!isok"
              style="width: 19px;height: 11px"
              @click="isshow"
              :src="passwordImg2"
              alt
            />
          </div>
          <el-button
            type="primary"
            @click="changePassword"
            style="margin-top: 30px;"
            :disabled="successButton"
          >确认修改</el-button>
          <div class="main-bottom">
            <span style="float:right">
              <router-link to="/">已有账号，立即登录</router-link>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crypto from "crypto";
export default {
  name: "login",
  data() {
    return {
      successButton: true, //确认按钮
      phoneCode: "", //短信验证码
      passWord: "", //密码
      imgToken: "", //用户输入的图形验证码
      phoneNumber: "", //输入手机号
      passwordImg: require("../../assets/icon/bxsmm.png"),
      passwordImg2: require("../../assets/icon/xsmm.png"),
      isok: true, //控制密码的显隐
      imageCaptchaUrl: "", //验证图片
      imageCaptchaToken: "", //图片验证令牌
      isRemember: false, //控制是否记住密码
      //国家首号下拉列表
      options: [
        {
          value: "选项1",
          label: "中国+86"
        },
        {
          value: "选项2",
          label: "美国+32"
        },
        {
          value: "选项3",
          label: "英国+43"
        },
        {
          value: "选项4",
          label: "日本+69"
        },
        {
          value: "选项5",
          label: "新加坡+52"
        }
      ],
      value: "中国+86"
    };
  },
  methods: {
    //发送短信验证码
    loginTo(e) {
      console.log(this.phoneNumber, this.imageCaptchaToken, this.imgToken);
      var that = this;
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;

      if (this.phoneNumber == "") {
        alert("请输入手机号码");
      } else if (!reg.test(this.phoneNumber)) {
        alert("手机格式不正确");
      } else {
        this.request
          .post("qrcapi/Login_findPassCaptcha", {
              userName: this.phoneNumber,
              imageCaptchaToken: this.imageCaptchaToken,
              imageCaptchaCode: this.imgToken})
          .then(function(response) {
            console.log(response)
            
            if (response.code == 1) {
              // alert("验证码已发送");
              that.$message({
                message: response.msg,
                type: "success"
              });
            } else {
              that.reqImg();
              that.$message.error(response.msg);
            }
          })
          .catch(function(error) {
            that.$message.error(response.msg);
            console.log(error);
          });
      }
    },
    //点击验证码
    changeImg() {
      this.reqImg();
    },
    isshow: function() {
      this.isok = !this.isok;
      if (this.isok) {
        this.$refs.password.type = "password";
      } else {
        this.$refs.password.type = "text";
      }
    },
    //确认修改密码
    changePassword() {
      var that = this;
   
      // md5加密 32位大写
      var passWord = this.passWord;
      // var md5 = crypto.createHash("md5");
      // md5.update(passWord);
      // passWord = md5.digest("hex");
      // passWord = passWord.toUpperCase();
      console.log(passWord)
   console.log(this.phoneCode, passWord, this.phoneNumber);
      this.request
        .post("qrcapi/Login_findPassWord", {
            userName: this.phoneNumber,
            passWord: passWord,
            captcha: this.phoneCode})
        .then(function(response) {
          that.reqImg();
          if (response.code == 1) {
            // alert();
            that.$message({
              message: response.msg,
              type: "success"
            });
            that.$router.push("/");
          } else {
            that.$message.error(response.msg);
          }
          console.log(response);
        })
        .catch(function(error) {
          that.$message.error(response.msg);
          console.log(error);
        });
    }
  },
  watch: {
    //两次密码验证
    passWord: function() {
      var reg = /^[a-zA-Z]{1}([a-zA-Z0-9]|[._]){7,19}$/;
      // var phoneNumber = this.phoneNumber
      var pass = this.pass;
      var passWord = this.passWord;
      var imgToken = this.imgToken;
      var phoneCode = this.phoneCode;
      if (reg.test(passWord)) {
        console.log("11");
        this.successButton = false;
      } else {
        this.successButton = true;
        console.log("2");
      }
    }
  },
  created() {
    this.reqImg(); //获取图片验证码
  }
};
</script>
<style scoped>
.imageCaptchaUrl {
  position: absolute;
  height: 30px;
  width: 85px;
  right: 0;
  top: 0;
}
</style>




// WEBPACK FOOTER //
// src/components/page/forgetThePassword.vue